(function () {



    $("body").on("click", ".send-sms-btn", function () {
        console.log("send it!");
        $(this).html('<i class="fa fa-spinner fa-spin"></i> Send');



        var message = $(".sendSMSForm #message").val();
        var id = $(".sendSMSForm input[name=id]").val();
             callAPI("POST", "crm/circle-sms/store", {
            uauth: uauthToken,
            id: id,
            message: message,
        })
            .done(function (response) {
                $(this).html("Send");
                // window.location.href = "/circles";
                location.reload();
            })
            .fail(function (response) {
                if (response.responseJSON.success == false) {
                    $(".sendSMSForm .save-btn").html("Send");

                    $(".error").css("display", "block");
                    $(".error").find("span:first").html("");
                    $(".error").find(".error-sms").html("");
                    $(".error")
                        .find("span:first")
                        .html(response.responseJSON.message);
                    $(".error")
                        .find(".error-sms")
                        .html(response.responseJSON.message["message"]);
                    $(this).html("Send");
                    $("#sendSMSForm").find("save-btn").html("Send");
                }
            });
    });
})();
